import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { createAdvancedMarker } from './html-map-marker';
import { getHeaders } from '../pricetravel/shared/tokenUtil';


export class GoogleMapDetail {
    constructor(scope, http, timeout, config, fn, hotel, box) {
        this.$scope = scope;
        this.$http = http;
        this.$timeout = timeout;
        this.config = config;
        this.fn = fn;
        this.hotel = hotel;
        this.box = box;

        this.mapInstance = null;
        this.markerCluster = null;
        this.nearbyMarkers = [];
        this.nearbyHotels = [];
        this.lib = { marker: null };
        this.vm = scope.vm;
    }

    async init(mapElement) {
        if (!this.vm.config) this.vm.config = {};
        if (!this.vm.config.limitHighlightElement) {
            this.vm.config.limitHighlightElement = this.config.limitHighlightElement;
        }

        if (!this.hotel || !this.hotel.location ||
            typeof this.hotel.location.latitude === 'undefined' ||
            typeof this.hotel.location.longitude === 'undefined') {
            return;
        }

        const latLng = {
            lat: +this.hotel.location.latitude,
            lng: +this.hotel.location.longitude
        };

        try {
            await this.initializeGoogleMap(mapElement, latLng);
            
            const { AdvancedMarkerElement } = this.lib.marker;

            // Marcador Principal
            const mainMarker = new AdvancedMarkerElement({
                map: this.mapInstance,
                position: new google.maps.LatLng(latLng.lat, latLng.lng),
                content: this.createMainMarkerContent(),
                title: this.hotel.name,
                zIndex: 1000
            });

            this.initMainCard(latLng);

            mainMarker.addListener('click', () => {
                this.mapInstance.panTo(latLng);
                this.initMainCard(latLng, true);
            });

            this.mapInstance.addListener('click', () => {
                this.closeMapCard();
            });

            // Cargar cercanos
            await this.loadNearbyHotels(latLng.lat, latLng.lng, latLng);

        } catch (error) {
            console.error("Error initializing GoogleMapDetail:", error);
        }
    }

    async initializeGoogleMap(mapElement, center, zoom = 17) {
        this.lib.maps = await google.maps.importLibrary("maps");
        this.lib.marker = await google.maps.importLibrary("marker");
        
        const { Map } = this.lib.maps;

        this.mapInstance = new Map(mapElement, {
            center: center,
            zoom: zoom,
            mapId: 'hotel_list_map',
            renderingType: 'VECTOR',
            tilt: 60,
             heading: 0,
            disableDefaultUI: true,
            zoomControl: false,
            rotateControl: true,
            tiltControl: true,
            gestureHandling: "greedy",
            clickableIcons: false,
            styles: this.getMapStyles()
        });
    }

    getMapStyles() {
        return [
            { featureType: "poi.attraction", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.business", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.place_of_worship", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "on" }] },
            { featureType: "poi.lodging", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] }
        ];
    }

    createMainMarkerContent() {
        const container = document.createElement('div');
        container.id = `hotel_bubble_${this.hotel.hotelId}`;
        container.className = `speech-bubble no-price speech-bubble-active main-bubble`;

        let innerHTML = '';
        if (this.hotel.isFavorite) {
            innerHTML += '<i class="icons-heart"></i>';
        }
        innerHTML += '<span><i class="icons-hotel-regular-full"></i></span>';
        container.innerHTML = innerHTML;
        return container;
    }

    initMainCard(latLng, show = false) {
        this.$scope.$applyAsync(() => {
            let campaignObj = null;
            if (window.__pt && Array.isArray(window.__pt.campaings)) {
                for (const campaign of window.__pt.campaings) {
                    if (campaign && campaign.badgeType && Array.isArray(campaign.targetProductIds) && campaign.targetProductIds.includes(Number(this.hotel.hotelId))) {
                        campaignObj = Object.assign({}, campaign, { badgeType: campaign.badgeType.trim().toLowerCase() });
                        break;
                    }
                }
            }
            const placeholderCode = this.config && this.config.siteName === "tiquetesbaratos" ? "co" : "us";
            this.vm.detailCardMap = {
                hotelId: this.hotel.hotelId,
                id: this.hotel.hotelId,
                productType: 1,
                name: this.hotel.name,
                stars: this.hotel.stars,
                gallery: this.hotel.gallery?.length
                    ? this.hotel.gallery
                        .filter(g => g.cloudUri)
                        .slice(0, 5)
                        .map(g => ({ cloudUri: `${g.cloudUri}?tx=g_auto,c_fill,w_400,h_250` }))
                    : [{ cloudUri: `/assets/img/placeholder_img_${placeholderCode}.png` }],
                isLoadGallery: true,
                highlights: [
                    ...(this.hotel.sellingPoints || []).map(sp => ({
                        info: [sp.title, ...(sp.items || [])].filter(Boolean).join(', ')
                    })),
                    ...(this.hotel.importantFacilities || []).map(f => ({ info: f }))
                ],
                surveyAverage: this.hotel.surveyAverage,
                dateRecommended: [],
                taxes: this.vm.cheaperRoomRate?.taxes
                    ? {
                        ...this.vm.cheaperRoomRate.taxes,
                        cancellationPolicies: this.vm.cheaperRoomRate.cancellationPolicies,
                        mealPlanCode: this.vm.cheaperRoomRate.mealPlanCode,
                        collectType: this.vm.cheaperRoomRate.collectType,
                        promotion: this.vm.cheaperRoomRate.promotion,
                        rooms: 1
                    }
                    : undefined,
                hasPrice: this.vm.cheaperRoomRate?.taxes?.totalRoomRatePerNight > 0,
                campaignObj: campaignObj,
                locationInfo: {
                    city: this.hotel.location?.city,
                    state: this.hotel.location?.state
                },
                url: null
            };
            if (show) this.vm.showCardMap = true;
        });
    }

    async loadNearbyHotels(latitude, longitude, latLng) {
        const paxes = this.vm.paxFam;
        const pax = paxes.paxesFormat.map(item => {
            if (!item.includes('|') && /^[0-9]+$/.test(item)) {
                item += '/n';
            }
            return item.replace(/\|/g, '/');
        }).join('/');

        const params = {
            culture: window.__pt.cultureData.internalCultureCode,
            Latitude: latitude,
            Longitude: longitude,
            radiusKm: 50,
            site: this.config.domain,
            SiteSearch: this.config.code,
            channelId: this.config.channelFac,
            checkin: this.box.checkIn,
            checkout: this.box.checkOut,
            mobile: false,
            pax: `/${pax}`,
            rooms: paxes.paxesFormat,
        };

        try {
            const response = await this.$http.get(this.config.endPoints.nearbyHotelsUrl, { params, headers: getHeaders() });
            if (response.data && response.data.hotels) {
                this.nearbyHotels = response.data.hotels;
                this.renderNearbyMarkers(latLng);
            }
        } catch (error) {
            console.error("Error loading nearby hotels:", error);
        }
    }

    async renderNearbyMarkers(latLng) {
        if (!this.mapInstance || !this.lib.marker) return;
        const { AdvancedMarkerElement } = this.lib.marker;

        if (this.markerCluster) {
            this.markerCluster.clearMarkers();
            this.markerCluster = null;
        }
        this.nearbyMarkers.forEach(m => m.map = null);
        this.nearbyMarkers = [];

        const markersToCluster = [];
        const coordMap = new Map();
        const currentHotelId = this.hotel.hotelId;

        for (const h of this.nearbyHotels) {
            try {
                if (h.hotelId == currentHotelId) continue;

                let loc = h.locationInfo || {};
                let lat = parseFloat(loc.latitude);
                let lng = parseFloat(loc.longitude);

                if (isNaN(lat) || isNaN(lng)) continue;

                if (h.surveyAverage) {
                    h.surveyAverage.averageValue = (h?.surveyAverage?.averageValue ?? 0) * 2;
                }

                const key = `${lat.toFixed(6)},${lng.toFixed(6)}`;
                const count = coordMap.get(key) || 0;
                coordMap.set(key, count + 1);
                if (count > 0) {
                    lat += (Math.random() - 0.5) * 0.00015;
                    lng += (Math.random() - 0.5) * 0.00015;
                }

                const price = h.taxes?.totalRoomRatePerNight;
                const hasPrice = price > 0;
                const html = `
                    <div id="hotel_bubble_${h.hotelId}" class="speech-bubble ${!hasPrice ? 'no-price' : ''}">
                        ${this.vm.isFavoriteHotel(h.hotelId) ? '<i class="icons-heart"></i>' : ''}
                        <span>${hasPrice ? this.vm.renderCurrencyDisplay(price) : '<i class="icons-hotel-regular-full"></i>'}</span>
                    </div>`;

                const marker = await createAdvancedMarker({
                    latlng: new google.maps.LatLng(lat, lng),
                    map: null,
                    id: h.hotelId,
                    html: html,
                    title: h.name,
                    zIndex: 10,
                    collisionBehavior: google.maps.CollisionBehavior.REQUIRED,
                    AdvancedMarkerElement
                });

                const hotelUrl = `${this.config.siteUrl}${this.config.pathHotelDetail}${h.uri}?${this.fn.objectToQueryParams({
                    checkin: this.box.checkIn,
                    checkout: this.box.checkout || this.box.checkOut,
                    ...this.fn.mapPaxToUrl(this.box.pax),
                    ...((typeof window._campaignToken !== 'undefined' && window._campaignToken) ? { CampaignToken: window._campaignToken } : {})
                })}`;

                marker.addListener("click", () => {
                    this.$scope.$applyAsync(() => {
                        let campaignObj = null;
                        if (window.__pt && Array.isArray(window.__pt.campaings)) {
                            for (const campaign of window.__pt.campaings) {
                                if (campaign && campaign.badgeType && Array.isArray(campaign.targetProductIds) && campaign.targetProductIds.includes(Number(h.hotelId))) {
                                    campaignObj = Object.assign({}, campaign, { badgeType: campaign.badgeType.trim().toLowerCase() });
                                    break;
                                }
                            }
                        }
                        this.vm.detailCardMap = {
                            hotelId: h.hotelId,
                            id: h.hotelId,
                            productType: 1,
                            name: h.name,
                            stars: h.stars,
                            gallery: h.mainPhoto?.cloudUri
                                ? [{ cloudUri: `${h.mainPhoto.cloudUri}?tx=g_auto,c_fill,w_400,h_250` }]
                                : [{ cloudUri: `/assets/img/placeholder_img_${this.config && this.config.siteName === "tiquetesbaratos" ? "co" : "us"}.png` }],
                            highlights: h.highlights || [],
                            surveyAverage: h.surveyAverage,
                            dateRecommended: h.dateRecommended || [],
                            taxes: h.taxes,
                            hasPrice: hasPrice,
                            campaignObj: campaignObj,
                            locationInfo: {
                                city: h.locationInfo?.city,
                                state: h.locationInfo?.state
                            },
                            url: hotelUrl
                        };
                        this.vm.showCardMap = true;

                        $(".speech-bubble.speech-bubble-active:not(.main-bubble)").removeClass('speech-bubble-active');
                        setTimeout(() => {
                            const el = document.getElementById(`hotel_bubble_${h.hotelId}`);
                            if (el) el.classList.add('speech-bubble-active');
                        }, 100);
                    });
                });

                this.nearbyMarkers.push(marker);
                markersToCluster.push(marker);

            } catch (err) {
                console.error("Error creating marker:", err);
            }
        }

        if (markersToCluster.length > 0) {
            const bg = getComputedStyle(document.documentElement).getPropertyValue('--marker-cluster-bg').trim();
            this.markerCluster = new MarkerClusterer({
                map: this.mapInstance,
                markers: markersToCluster,
                onClusterClick: (event, cluster, map) => {
                    const markers = cluster.markers;
                    if (markers && markers.length > 0) {
                        const bounds = new google.maps.LatLngBounds();
                        markers.forEach(m => bounds.extend(m.position));
                        const currentZoom = map.getZoom();
                        map.fitBounds(bounds, { top: 150, right: 150, bottom: 150, left: 150 });
                        setTimeout(() => {
                            if (map.getZoom() <= currentZoom) {
                                map.setZoom(currentZoom + 2);
                            }
                        }, 100);
                        return false;
                    }
                },
                renderer: {
                    render: ({ count, position }) => {
                        const div = document.createElement('div');
                        div.className = 'marker-cluster';
                        div.style.cssText = `
                            background: ${bg}; color: white; border: 2px solid rgba(255,255,255,0.95);
                            border-radius: 50px; padding: 0 12px; min-width: 40px; height: 32px;
                            display: flex; align-items: center; justify-content: center;
                            font-weight: 800; font-size: 15px; box-shadow: 0 6px 16px rgba(0,0,0,0.3);
                            letter-spacing: -0.2px; white-space: nowrap;
                            font-family: 'Outfit', sans-serif; cursor: pointer;
                            transition: transform 0.2s ease;
                        `;
                        div.innerHTML = `<span>+${count}</span>`;
                        return new AdvancedMarkerElement({ position, content: div, zIndex: 2000 });
                    }
                }
            });
        }
    }

    closeMapCard() {
        this.$timeout(() => {
            this.vm.showCardMap = false;
            $(".speech-bubble.speech-bubble-active:not(.main-bubble)").removeClass('speech-bubble-active');
        });
    }

    geolocate() {
        if (navigator.geolocation && this.mapInstance) {
            navigator.geolocation.getCurrentPosition((position) => {
                const userLatLng = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                new google.maps.Marker({
                    position: userLatLng,
                    map: this.mapInstance,
                    icon: {
                        url: `${this.config.cloudCdn}/assets/img/point.png`,
                        scaledSize: new google.maps.Size(25, 25)
                    }
                });
                this.mapInstance.setCenter(userLatLng);
            }, (error) => {
                console.warn("Geolocation error:", error);
            });
        }
    }

    zoomIn() {
        if (this.mapInstance) this.mapInstance.setZoom(this.mapInstance.getZoom() + 1);
    }

    zoomOut() {
        if (this.mapInstance) this.mapInstance.setZoom(this.mapInstance.getZoom() - 1);
    }
}

